module.exports = __webpack_public_path__ + "static/media/mobile.65d565ef.png";